import React, { Component, Fragment } from 'react';
import { Document } from 'components';
import { Plans } from '.';
import css from './programs.scss';

export class Programs extends Component {

  componentDidMount() {
    setTimeout(this.props.setReady, 0);
  }

  render() {
    return (
      <Fragment>
        <Document.Title>Programs</Document.Title>
        <Document.Description>All Premium plans include full access to all features and functionality in the mobile apps (iPhone, iPad, Android) and full unlimited access to the comprehensive Web Program.</Document.Description>
        <Plans {...this.props} />
        <div className={css.section}>
          <div className={css.container}>
            <h2>60-Day Guarantee</h2>
            <p>We are confident that if you commit to the program and are actively engaged with the inquires and practices on a regular basis, you will transform your life. If after actively using the Success Wizard program for 60 days you don't feel it made a significant impact on your life, simply contact us at support@successwizard.com and we will promptly refund the membership fees you paid for the first 60 days. (The refund does not include any used personal coaching sessions).</p>
          </div>
        </div>
      </Fragment>
    );
  }

}
